module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_Icon_4_CN.553417d6.png";